import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent, RouteDataService } from '@ridango/core';
import { takeUntil } from 'rxjs/operators';

@Component({
    templateUrl: './explore-route-patterns-page.component.html'
})
export class ExploreRoutePatternsPageComponent extends BaseComponent implements OnInit, OnDestroy {
    constructor(
        private route: ActivatedRoute,
        private routeDataService: RouteDataService
    ) {
        super();
    }

    ngOnInit(): void {
        this.route.params.pipe(takeUntil(this.componentDestroyed$)).subscribe((params) => {
            const routeId = params['routeId'];
            if (routeId) {
                this.routeDataService.setRouteId(routeId);
            }
        });
    }

    ngOnDestroy(): void {
        this.routeDataService.setRouteId(null);
        super.ngOnDestroy();
    }
}
